// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nduD","select":"styles_select__2t4_h"};